import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import closeIcon from '../../assets/images/closeIcon.svg';

import CancelButton from '../../components/Buttons/CancelButton';
import ConfirmButton from '../../components/Buttons/ConfirmButton';

import classes from './styles.module.scss';

export default function ConfirmActionModal({
  title = 'Whoa wait!',
  show,
  handleClose,
  message,
  children,
  onConfirm,
  noButtons,
  timeToClose,
  confirmDisabled = false,
}) {
  // Auto-close modal if timeToClose is provided (useful for noButtons success messages)
  useEffect(() => {
    if (timeToClose && show) {
      const timer = setTimeout(() => {
        handleClose();
      }, timeToClose);

      return () => clearTimeout(timer);
    }
    return undefined;
  }, [timeToClose, show, handleClose]);

  const renderBody = () => {
    if (children) {
      return <div className={classes.messageNode}>{children}</div>;
    }

    if (typeof message === 'string') {
      return (
        <p
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: message }}
        />
      );
    }

    if (message) {
      return <div className={classes.messageNode}>{message}</div>;
    }

    return null;
  };

  return (
    <Modal
      show={show}
      centered
      contentClassName={classes.ConfirmActionModal}
      dialogClassName={classes.dialog}
      backdropClassName={classes.backdrop}
      onHide={handleClose}
    >
      <i className={classes.closeIcon} onClick={handleClose}>
        <img src={closeIcon} alt="Close" />
      </i>
      <div className={classes.content}>
        <h3>{title}</h3>
        {renderBody()}
        {!noButtons && (
          <div className={classes.buttons}>
            <CancelButton onClick={handleClose} />

            <ConfirmButton
              isDisabled={confirmDisabled}
              onClick={() => {
                if (confirmDisabled) return;
                onConfirm();
                handleClose();
              }}
              data-testid="confirm-delete-button"
            />
          </div>
        )}
      </div>
    </Modal>
  );
}
